export const Routes = {
  // User
  // dashboard: () => '/dashboard',
  notificationTimeline: () => '/messages/timeline',
  notificationFavolites: () => '/messages/favorites',
  draftNotifications: () => '/messages/timeline/draft',
  conversation: () => '/messages/conversations',
  analytics: () => '/messages/analytics',
  topics: () => '/topics',
  topicDetail: () => '/topics/:topicsId',
  profileInfo: () => '/profile',
  createNotification: () => '/notifications/create-notification',
  dealsPromotions: () => '/deals-promotions',
  createDealsPromotions: () => '/deals-promotions/create',
  groups4: () => '/groups4',
  groupsDetailV4: () => '/groups4/:groupId',
  viewGroups: (id) => `/groups4/${id}`,
  groups: () => '/groups',
  groupsDetail: () => '/groups/:groupId',
  viewGroupDetail: (id) => `/groups/${id}`,
  manageBeacon: () => '/beacon/manage',
  beaconNotification: () => '/beacon/notification',
  planAndBilling: () => '/settings/plan-and-billing',
  socialMediaIntegrations: () => '/integrations/social-media-integrations',
  changePlan: () => '/settings/plan-and-billing/change-plan',
  teamMembers: () => '/settings/team-members',
  initialInvite: () => '/settings/initial-invite',
  initialNotification: () => '/settings/initial-notification',
  editTeamMember: (id) => `/team-members/${id}`,
  roles: () => '/settings/roles-permissions',
  memberCard: () => `/member-card`,
  viewTopics: (id) => `/topics/${id}`,
  manageChannels: () => '/settings/manage-channels',
  billingOverview: () => '/billings/billing-overview',
  billingchangePlan: () => '/billings/billing-overview/change-plan',
  usageSummary: () => '/billings/usage-summary',
  usageHistory: () => '/billings/usage-history',
  aiUsageLog: () => '/billings/ai-usage-log',
  subscribersV4: () => '/subscribers',
  subscribersV4Detail: () => '/subscribers/:subscriberId',
  viewSubscriberDetail: (subscriberId) => `/subscribers/${subscriberId}`,
  importSubscriberV4: () => '/subscribers/import',
  profileInfoV4: () => '/profile-info',

  // Guest
  root: () => '/',
  login: () => '/login',
  redemption: (historyId) => `/redeem/vouchers/${historyId}`,
  redemptionBase: () => `/redeem/vouchers`,
  subscriberWidget: () => '/integrations/subscriber-widget',
  permissionDenied: () => `/groups/permission-denied`,
  maintenance: () => `/maintenance`,
  socialMediaIntegrationsBeewo: () => '/social-auth/redirect',
  // Guest V4
  signIn: () => '/sign-in',
  forgotPassword: () => '/forgot-password',
  resetPassword: () => '/reset-password',
  facebookCallback: () => '/auth/facebook/callback',

  curatedRegisterSuccess: () => '/curated/register-success',
  registerSuccess: () => '/register-success',
}
